import { render, staticRenderFns } from "./Dui.vue?vue&type=template&id=0e0804ee&"
import script from "./Dui.vue?vue&type=script&lang=js&"
export * from "./Dui.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports